import { gql } from '__generated__';

export default gql(`
  mutation InviteParticipants($input: InviteParticipantsInput!) {
    inviteParticipants(input: $input) {
      id
    }
  }
`);
